import React from "react";

import { FeeBadgeWrapper } from "./FeeBadge.styles";
import PropTypes from "prop-types";
import "animate.css";

const FeeBadge = ({ feePriceTraditional, messageTraditional, feePriceNonTraditional, messageNonTraditional }) => {
  const LongPrice = price => {
    return `$${new Intl.NumberFormat().format(price)}`;
  };

  return (
    <FeeBadgeWrapper className="animate__fadeInDown">
      <span className="fee__price"> {LongPrice(+feePriceTraditional)}</span>
      <p className="fee__price-label"> Tarifa DdC Tradicional </p>
      <div className="fee__alert-container">
        <span className="fee_icon">ℹ️</span>
        <p className={`fee__label`}>
          {messageTraditional}
        </p>
      </div>
      <span className="fee__price"> {LongPrice(+feePriceNonTraditional)}</span>
      <p className="fee__price-label"> Tarifa DdC no Tradicional </p>
      <div className="fee__alert-container">
        <span className="fee_icon">ℹ️</span>
        <p className={`fee__label`}>
          {messageNonTraditional}
        </p>
      </div>
    </FeeBadgeWrapper>
  );
};

FeeBadge.propTypes = {
  feePriceTraditional: PropTypes.string,
  messageTraditional: PropTypes.string,
  feePriceNonTraditional: PropTypes.string,
  messageNonTraditional: PropTypes.string,
};

export default FeeBadge;
